import ItemAvailabilityNotification from "./components/itemAvailabilityNotification.component.vue";

export function createApp()
{
    Vue.component("cyt-item-availability-notification", ItemAvailabilityNotification);
}
